// Shared by marketing links and app arrival without importing either runtime.
export const interfaceLanguageHintParam = "app_locale";
